// extracted by mini-css-extract-plugin
export default {"component":"BonusQuickActions__component--lc-_ZdGC","button":"BonusQuickActions__button--lc-l8H8p","details":"BonusQuickActions__details--lc-G52r8"};